import { concat } from "../TemplateResult.mjs";
export default (() => ({
  prologueResult: null,

  prologue(strings, ...values) {
    return { ...this,
      prologueResult: concat(this.prologueResult, strings, values, {
        newLineSeparator: false
      })
    };
  }

}));